module.exports = __webpack_public_path__ + "static/crystalHeartMobile-9ce3f285f60a2267b37fe6547d4b5fcf.png";